(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["localization-panel"] && !Shopify.designMode) return;
  try {
    function initVyraLocale(scope=document){
  scope.querySelectorAll('[data-vyra-locale]').forEach(panel=>{
    if(panel.dataset.ready)return;panel.dataset.ready='true';
    const country=panel.querySelector('[name="country_code"]'),language=panel.querySelector('[name="language_code"]'),summary=panel.querySelector('summary'),currencyForm=panel.querySelector('[data-vyra-currency-sync]');
    let preference;
    try{preference=sessionStorage.getItem('vyra-country-choice');}catch{}
    if(preference&&Array.from(country.options).some(option=>option.value===preference))country.value=preference;
    const highlight=()=>panel.querySelectorAll('[data-locale-country]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.localeCountry===country.value)));
    const sync=()=>{highlight();const locale={US:'en',FR:'fr',DE:'de'}[country.value];if(locale&&Array.from(language.options).some(option=>option.value===locale))language.value=locale;};
    country.addEventListener('change',sync);
    panel.querySelectorAll('[data-locale-country]').forEach(button=>button.addEventListener('click',()=>{country.value=button.dataset.localeCountry;sync();}));
    country.form.addEventListener('submit',()=>{try{sessionStorage.setItem('vyra-country-choice',country.value);sessionStorage.removeItem('vyra-currency-sync');}catch{}});
    panel.querySelector('[data-locale-close]').addEventListener('click',()=>{panel.open=false;summary.focus();});
    panel.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();panel.open=false;summary.focus();}});
    highlight();
    const option=country.selectedOptions[0],expected=option.dataset.currency;
    if(panel.dataset.currentCurrency===expected){
      panel.querySelector('.vyra-locale-code').textContent=country.value+' · ';
      const flag=summary.querySelector('img');flag.removeAttribute('srcset');flag.src=option.dataset.flag;
      return;
    }
    currencyForm.querySelector('[name="currency"]').value=expected;
    const stamp=country.value+':'+expected;
    try{
      const previous=JSON.parse(sessionStorage.getItem('vyra-currency-sync')||'null');
      if(previous&&previous.stamp===stamp&&Date.now()-previous.time<15000){currencyForm.parentElement.hidden=false;return;}
      sessionStorage.setItem('vyra-currency-sync',JSON.stringify({stamp,time:Date.now()}));
    }catch{}
    currencyForm.requestSubmit();
  });
}
initVyraLocale();
document.addEventListener('click',event=>{document.querySelectorAll('[data-vyra-locale][open]').forEach(panel=>{if(!panel.contains(event.target))panel.open=false;});});
document.addEventListener('shopify:section:load',event=>initVyraLocale(event.target));
  } catch(e) { console.error(e); }
})();

})();
